import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

/* VARIATION BEING USED ON THE CAMPAIGN EXPIRATION PAGE AND 404 */
export const PageNotFoundWrapperStyles = css`
  &.static-404,
  &.static-offer-expired {
    margin: 0 auto;
    max-width: 1200px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 40px);
    flex-direction: column;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex-direction: row;
    }
  }
`;

export const PageNotFoundContentStyles = css`
  ${PageNotFoundWrapperStyles}.static-404 &,
  .static-offer-expired & {
    width: 100%;
    padding: 3rem 0;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 50%;
      padding: 4rem 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 55%;
    }

    h1 {
      font-size: 3rem;
      line-height: 3.3rem;
      color: ${themeGet('colors.main-text')};

      &:lang(fr) {
        font-size: 2.5rem;
        line-height: 3rem;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 4rem;
        line-height: 4.7rem;

        &:lang(fr) {
          font-size: 3rem;
          line-height: 3.25rem;
        }
      }
    }

    p {
      font-size: 1.25rem;
      line-height: 1.7rem;
      color: ${themeGet('colors.main-text')};
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding-right: 2rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 50%;
    }
  }

  ${PageNotFoundWrapperStyles}.static-404 & {
    order: 1;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      order: 0;
    }
  }
`;

export const PageNotFoundIntroStyles = css`
  ${PageNotFoundWrapperStyles}.static-404 &,
  .static-offer-expired & {
    max-width: none;
  }
`;

export const PageNotFoundMediaContainerStyles = css`
  ${PageNotFoundWrapperStyles}.static-404 &,
  .static-offer-expired & {
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: center;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 40%;
    }

    &.cover {
      @media only screen and (max-width: 1023px) {
        display: none;
      }
    }
  }

  ${PageNotFoundWrapperStyles}.static-404 & {
    order: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      order: 1;
    }
  }
`;

export const PageNotFoundHeroImageStyles = css`
  &.contain {
    ${PageNotFoundWrapperStyles}.static-404 &,
    .static-offer-expired & {
      height: auto;
      max-height: 350px;
      margin: 0 auto 3rem;
    }
  }

  &.contain {
    ${PageNotFoundWrapperStyles}.static-404 & {
      margin: 3rem auto 0;
    }
  }

  ${PageNotFoundWrapperStyles}.static-offer-expired & {
    max-width: 450px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${PageNotFoundWrapperStyles}.static-404 &,
    .static-offer-expired & {
      &:lang(fr) {
        height: 600px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.contain {
      ${PageNotFoundWrapperStyles}.static-404 &,
      .static-offer-expired & {
        margin: 2.75rem auto;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.contain {
      ${PageNotFoundWrapperStyles}.static-404 &,
      .static-offer-expired & {
        margin: 3.75rem auto;
      }
    }
  }
`;
